import { Component, Inject } from '@angular/core';
import { SimpleConfirmDialogConfig } from '../../interfaces/confirm-dialog-config/simple-confirm-dialog-config';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'cas-simple-confirm-dialog',
    templateUrl: './simple-confirm-dialog.component.html',
})
export class SimpleConfirmDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<SimpleConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SimpleConfirmDialogConfig
    ) {
    }
}
